// 验证规则集合
let tel =
  /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|16[0-9]|17[0-9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/; //手机号码
// let name = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,10}$/; //姓名
// let whonumber=/^\d{15}|\d{18}$/;  // 身份证验证
let nickname = /^[0-9a-zA-Z]{3,20}$/; // 昵称
let ip =
  /((?:(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d)\\.){3}(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d))/g; //ip地址
let url = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w-.\\/?%&=]*)?/; //网址
let only = /^[\da-z]+$/i; // 只能输入数字和字母
// let chineseName = /^([\u4e00-\u9fa5]){2,10}$/; // 中文姓名
// let bank = /^([1-9]{1})(\d{14}|\d{18}|\d{15})$/; // 银行卡号
// let email = /^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})$/; //邮箱
let email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/; // 邮箱
let number = /^(\d)*$/; // 数字
let repace = /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,8}\.\d{1,2}$|^[1-9]\d{0,8}$/; //价格校验
let ems = /^[1-9][0-9]{5}$/; // 邮政
// let znumber = /^([1-9][0-9]*){1,3}$/; // 正数
// let pass = /^[0-9a-zA-Z_]{6,12}$/; // 密码  数字、字母、下划线
let pass = /^[0-9a-zA-Z]\w{5,17}$/; // 6-18位数字字母下划线
// 长度在6~18之间，只能包含字母、数字和下划线)：^[0-9a-zA-Z]\w{5,17}$
let testfile = /(.in|.out)$/;


// 验证用户名
const isName = (rule, value, callback) => {
  if (!nickname.test(value)) {
    callback(new Error('用户名由3~20位字符组成'));
  } else {
    callback();
  }
};
//IP地址校验
function isIp(rule, value, callback) {
  if (!ip.test(value)) {
    callback(new Error('请输入正确的IP地址'));
  } else {
    callback();
  }
}
//联系电话校验
function isPhone(rule, value, callback) {
  if(value==''){
    callback();
  }
  if (!tel.test(value)) {
    callback(new Error('请输入正确的11位手机号码'));
  } else {
    callback();
  }
}
//上传文件校验
function isFileUpdate(rule, value, callback) {
  if (!value) {
    callback(new Error('请选择文件'));
  } else if (value.length < 1) {
    callback(new Error('请选择至少一个文件'));
  } else {
    callback();
  }
}
// //中文姓名校验
// function nameValidator(rule, value, callback) {
// 	if(value === '' || typeof(value) == 'undefined') {
// 		callback(new Error('请输入中文姓名'));
// 	} else if(!(chineseName.test(value))) {
// 		callback(new Error('请输入正确的姓名'));
// 	} else {
// 		callback();
// 	}
// }

//银行号码校验
// function bankNumValidator(rule, value, callback) {
//   if (value === "" || typeof value == "undefined") {
//     callback(new Error("请输入银行账号"));
//   } else if (!bank.test(value)) {
//     callback(new Error("请输入正确的银行账号"));
//   } else {
//     callback();
//   }
// }
//邮箱校验
function isEmail(rule, value, callback) {
  if (!email.test(value)) {
    callback(new Error('邮箱格式错误 请输入正确的邮箱'));
  } else {
    callback();
  }
}
//网址校验
function isUrl(rule, value, callback) {
  if (!url.test(value)) {
    callback(new Error('请输入正确的网址'));
  } else {
    callback();
  }
}
// function urlValidator2(rule, value, callback) {
//   if (value === "" || typeof value == "undefined") {
//     callback();
//   } else if (!url.test(value)) {
//     callback(new Error("请输入正确的网址"));
//   } else {
//     callback();
//   }
// }
//只能输入字母和数字，不能输入小数点
function isOnlyNandW(rule, value, callback) {
  if (value === '' || typeof value == 'undefined') {
    callback(new Error('请输入'));
  } else if (!only.test(value)) {
    callback(new Error('请输入正确的格式'));
  } else {
    callback();
  }
}
//数字校验
function isNumber(rule, value, callback) {
  if (!number.test(value)) {
    callback(new Error('(仅数字)请输入正确的数字'));
  } else {
    callback();
  }
}
//价格校验   数字    不可<0   可带小数点  小数点前小于等于9位   小数点后小于等于2位
function isMoney(rule, value, callback) {
  if (!repace.test(value)) {
    callback(new Error('请输入正确的金额'));
  } else if (value <= 0) {
    callback(new Error('金额不能为负数'));
  } else {
    callback();
  }
}
//邮政编码校验
function isPostCode(rule, value, callback) {
  if (!ems.test(value)) {
    callback(new Error('请输入正确的邮政编码'));
  } else {
    callback();
  }
}
//20个中文校验
// function codeLengthValidator(rule, value, callback) {
// 	if(value === '' || typeof(value) == 'undefined') {
// 		callback(new Error('请输入使用标准'));
// 	} else if(value.length > 20) {
// 		callback(new Error('最多输入20个描述文字'));
// 	} else {
// 		callback();
// 	}
// }

/**
 * 非空检验 true 非空 false 不为空
 */
// function validateNotEmpty(rule, value, callback) {
//   let message = rule && rule.message ? rule.message : "请输入内容";
//   let flag = false;
//   if (!value && ("number" != typeof value)) { //null undefined "" 非数字
//     callback && callback(new Error(message));
//   } else if (value instanceof Array) {//数组
//     if (value.length) {//数组有元素
//       flag = true;
//       callback && callback();
//     } else {
//       callback && callback(new Error(message));
//     }
//   } else if (value instanceof Object) {//对像
//     for (let i in value) {
//       flag = true;
//       callback && callback();
//       break;
//     }
//     callback && callback(new Error(message));
//   } else {
//     flag = true;
//     callback && callback();
//   }
//   return flag;
// }
// 数字和字母组成的6-16位密码校验
function isPassword(rule, value, callback) {
  if (!pass.test(value)) {
    callback(new Error('请输入数字、字母、下划线'));
  } else {
    callback();
  }
}

//  // 级联选择校验
function isRegion(rule, value, callback) {
  // if (value.length < 2) {
  //   callback(new Error("请至少选择二级选项"));
  // } else
  if (!value || value.length == 0) {
    callback(new Error('请至少选择一级选项'));
  } else {
    callback();
  }
}

function isFileTestname(rule, value, callback) {
  if (!testfile.test(value)) {
    callback(new Error('文件后缀名不正确（后缀名必须为.int或.out)'));
  } else {
    callback();
  }
}
export default {
  isName,
  isIp,
  isPhone,
  isFileUpdate,
  isEmail,
  isUrl,
  isOnlyNandW,
  isNumber,
  isMoney,
  isPostCode,
  isPassword,
  isRegion,
  isFileTestname
};